//= require bootstrap-datepicker
//= require bootstrap-datepicker/core
//= require bootstrap-datepicker/locales/bootstrap-datepicker.es.js
//= require bootstrap-datepicker/locales/bootstrap-datepicker.fr.js
//= require jquery-ui/autocomplete

// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import moment from "moment";
import { installSessionExpiredHandler } from "../utils/session_expired";

// Initializes Stimulus.js application and loads controllers directory

const application = Application.start();
const context = require.context("../controllers", true, /\.js$/);
application.load(definitionsFromContext(context));

require("@rails/ujs").start();
installSessionExpiredHandler(document, (url) => window.location.assign(url));
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("jquery");
// require("jquery_ujs")
// require("easy-autocomplete");
require("bootstrap");
require("daterangepicker");
require("packs/jquery.easy-autocomplete");
require("routes/index");
require("purchases/index");
require("agencies/index");
require("promotions/index");

window.initMap = function(...args) {
    const event = document.createEvent("Events")
    event.initEvent("google-maps-callback", true, true)
    event.args = args
    window.dispatchEvent(event)
}

window.moment = moment;